import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function InvResultView(props){
  const [selectedDate, setSelectedDate] = useState(new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000));
  const [invData, setinvData] = useState([]);


  useEffect(() => {
    fetchData();
    const intervalId = setInterval(fetchData, 15000); // Fetch data every 5 seconds
    return () => clearInterval(intervalId); // Cl
  }, [selectedDate]);

  function fetchData() {
    const formattedDate = selectedDate.toISOString().substring(0, 10);
    axios.get(baseUrl+'inv-files-view/'+formattedDate+'/')
      .then(response => {
        setinvData(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  }

const handleDateChange = (date) => {
    const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    setSelectedDate(localDate);
  };

   const rows = invData.filter(item => item.itest_id > 0).map(item => ({
      id: item.id,
      date_time: `${item.add_date} ${item.add_time}`,
      appt_id: item.appt.appt_id,
      pat__pat_id: item.pat.pat_id,
      pat__patient: item.pat.patient,
      inv_test: item.appt.inv_test,
      addedby: item.addedby,
    }));

  const columns = [
    { field: 'date_time', headerName: 'Date', width: 170 },
    { field: 'appt_id', headerName: 'Appt Id', width: 120},
    { field: 'pat__pat_id', headerName: 'Patient ID', width: 100},
    { field: 'pat__patient', headerName: 'Patient', width: 170 },
    { field: 'inv_test', headerName: 'Particulars', width: 400 },
    { field: 'addedby', headerName: 'Addedby', width: 100 },
    { field: 'view', headerName: 'Action',
        renderCell: (params) => (
          <Link to={`/inv-images/${params.row.id}`} target="_blank" className="btn btn-success">
            View
          </Link>
      ),
      width: 120 },
  ];

  return (
    <section className="container mt-4">
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label className="col-sm-3 col-lg-2 control-label">Select Date</label>
            <div className="col-sm-9 col-lg-10 controls">
              <DatePicker selected={selectedDate} onChange={handleDateChange} dateFormat="dd/MM/yyyy" />
            </div>
          </div>
        </div>
      </div>

         {invData.length > 0 ? (
        <div style={{ height: "100%", width: "100%" }}>
        <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-calendar-days"
            aria-hidden="true" style={{color: 'red'}}></i>  View Radiology Files</h3>
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            rows={rows}
            columns={columns}
            pageSize={10}
            sortModel={[
              {
                field: 'date_time', // The field you want to sort by (in this case, the first column with 'id' as the field name)
                sort: 'desc', // 'asc' for ascending order, 'desc' for descending order
              },
            ]}
            slots={{
              toolbar: GridToolbar,
            }}

            autoHeight
          />
        </div>
        ) : (
        <></>
      )}
    </section>
  )
}

export default InvResultView;
